import { render, staticRenderFns } from "./StockPositionWriteOffDetails.vue?vue&type=template&id=ca6c1bd4&"
import script from "./StockPositionWriteOffDetails.vue?vue&type=script&lang=js&"
export * from "./StockPositionWriteOffDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports